// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3H-jV","productName":"Table_productName__2EHmC"};